/**
 * Function format large number commas to a space
 * @param {number} x Number
 */
export function commasToSpace(x: number): string {
  return x?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export const truncateString = (string: string, limit: number): string => {
  if (string && string.length > limit) {
    return `${string.substring(0, limit)}...`;
  }
  return string;
};

export const secondsToMin = (time: number): string => {
  const date = new Date(time * 1000);
  const mm = date.getUTCMinutes();
  const ss = `0${date.getUTCSeconds()}`.slice(-2);
  return `${mm}:${ss}`;
};
